/**
 *
 * @description AppProvider.tsx
 * @author yikkok <yikok.yong@gmail.com>
 * @version 1.0.0
 * @since 19 February 2022
 *
 */

import { createContext, useContext, useEffect, useState } from 'react';
import { ChildrenT } from '~/@customTypes/generic';
import useLoading from '../hooks/useLoading';
import { fetchProductGroups } from '../modules/product-groups/product.service';
import { ProductGroupsT } from '../modules/product-groups/product.type';
import { ConfigContext, ConfigContextT } from './ConfigProvider';
import { LocaleContext, LocaleContextT } from './LocaleProvider';

export type AppContextT = {
  groups: ProductGroupsT[];
  loading: boolean;
};

export const AppContext = createContext<AppContextT>({
  groups: [],
  loading: false,
});

type Props = ChildrenT;
export default function AppProvider({ children }: Props) {
  const { locale } = useContext<LocaleContextT>(LocaleContext);
  const { currency } = useContext<ConfigContextT>(ConfigContext);

  const [groups, setGroups] = useState<ProductGroupsT[]>([]);

  const { onStartLoading, onStopLoading, loading } = useLoading();

  useEffect(() => {
    (async () => {
      onStartLoading();
      const result = await fetchProductGroups({ locale, currency });

      onStopLoading();
      if (result && result.data) {
        setGroups(result.data);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, currency]);

  return <AppContext.Provider value={{ groups, loading }}>{children}</AppContext.Provider>;
}
